import { destroy, get, post, put } from '.';

export function CreateRule(options = {}) {
	return post<any>("/app/api/rules", options);
}

export function DestroyRule(id:string) {
	return destroy<any>(`/app/api/rules/${id}`);
}

export function GetRules(options = {}) {
	return get<any>("/app/api/rules", options);
}

export function UpdateRule(id:string, options = {}) {
	return put<any>(`/app/api/rules/${id}`, options);
}